(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5308],{

/***/ 88529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[slug]",
      function () {
        return __webpack_require__(39996);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29261);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33434);




const FAQs = ({ faqData  })=>{
    const accordionItems = (faqData?.faqPoints ?? []).map((faq)=>({
            title: faq.title,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: faq.description
                }
            })
        }));
    if (!faqData || accordionItems.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-section"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-heading"]),
                    children: faqData?.title ?? ""
                }),
                faqData?.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-subtext"]),
                    dangerouslySetInnerHTML: {
                        __html: faqData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    items: accordionItems,
                    defaultOpenIndex: 0,
                    theme: "base",
                    icon: "plus"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 72767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = ({ width =13 , height =21 , color ="#0B0C2D"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 19L11.5 10.6667L1.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ }),

/***/ 30535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const CrossIcon = ({ width =20 , height =20 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 0.999939L1 12.9999M1 0.999939L13 12.9999",
            stroke: color,
            strokeWidth: "1.99991",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CrossIcon);


/***/ }),

/***/ 68613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Mail = ({ width =14 , height =14 , color ="#9A9AB0"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.6677 2.74982L7.42255 6.09024C7.24456 6.1936 7.04239 6.24805 6.83655 6.24805C6.63071 6.24805 6.42854 6.1936 6.25054 6.09024L1.00012 2.74982M2.16688 1H11.501C12.1453 1 12.6677 1.52228 12.6677 2.16655V9.16585C12.6677 9.81012 12.1453 10.3324 11.501 10.3324H2.16688C1.5225 10.3324 1.00012 9.81012 1.00012 9.16585V2.16655C1.00012 1.52228 1.5225 1 2.16688 1Z",
            stroke: color,
            "stroke-width": "2",
            "stroke-linecap": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Mail);


/***/ }),

/***/ 98188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20829);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Icons_CrossIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30535);





const Modal = ({ children , onClose , isOpen , contentClassName  })=>{
    const { 0: mounted , 1: setMounted  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
        return ()=>setMounted(false);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isOpen) return;
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = originalOverflow;
        };
    }, [
        isOpen
    ]);
    if (!isOpen || !mounted) return null;
    const handleBackdropClick = (e)=>{
        e.stopPropagation();
        onClose();
    };
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().backdrop),
        onClick: handleBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: contentClassName ?? (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-container"]),
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["close-button-container"]),
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["close-button"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_CrossIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            width: 12,
                            height: 12
                        })
                    })
                }),
                children
            ]
        })
    }), document.body);
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 39996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/StudyAbroad/FranchiseeComponent.tsx + 11 modules
var FranchiseeComponent = __webpack_require__(91582);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/PartnerCountry/PartnerCountry.module.scss
var PartnerCountry_module = __webpack_require__(50427);
var PartnerCountry_module_default = /*#__PURE__*/__webpack_require__.n(PartnerCountry_module);
// EXTERNAL MODULE: ./components/PartnerCountry/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(87027);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
;// CONCATENATED MODULE: ./components/PartnerCountry/HeroSection/HeroSection.tsx










const getCountryFromSlug = (slug)=>{
    const parts = slug?.split("-") ?? [];
    const inIndex = parts.lastIndexOf("in");
    if (inIndex === -1) return "";
    const country = parts.slice(inIndex + 1).join("");
    return country.charAt(0).toUpperCase() + country.slice(1);
};
const HeroSection = ({ partnerCountryData  })=>{
    const router = (0,next_router.useRouter)();
    const isMobile = (0,useIsMobile/* default */.Z)(1024);
    const heroSectionData = partnerCountryData?.heroSection ?? {};
    const country = getCountryFromSlug(partnerCountryData?.slug);
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: heroSectionData?.button?.link,
        formId: heroSectionData?.button?.formId,
        toOnboardingEnabled: heroSectionData?.button?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: heroSectionData?.button?.nearestOffice ?? true,
                    coachingVisible: heroSectionData?.button?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            id: "hero-section",
            className: (HeroSection_module_default())["hero-section-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                    className: (HeroSection_module_default())["hero-picture"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            media: "(max-width: 767px)",
                            srcSet: (isMobile ? heroSectionData?.mobileBgImg?.url : heroSectionData?.desktopBgImg?.url) ?? ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (isMobile ? heroSectionData?.mobileBgImg?.url : heroSectionData?.desktopBgImg?.url) ?? "",
                            loading: "eager",
                            fetchPriority: "high",
                            decoding: "async",
                            width: "100%",
                            height: "100%",
                            alt: "hero.webp"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HeroSection_module_default())["content-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HeroSection_module_default())["breadcrum-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                        style: {
                                            opacity: 0.5
                                        },
                                        href: "/",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                        href: "/partners/study-abroad-association",
                                        className: (HeroSection_module_default())["breadcrumb-item-2"],
                                        children: "For Partners"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                        href: "#",
                                        className: (HeroSection_module_default())["breadcrumb-item-2"],
                                        children: heroSectionData?.breadcrumbCountryLabel ?? country
                                    })
                                ]
                            })
                        }),
                        heroSectionData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HeroSection_module_default()).heading,
                            dangerouslySetInnerHTML: {
                                __html: isMobile ? heroSectionData?.mobileTitle : heroSectionData?.title
                            }
                        }),
                        heroSectionData?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HeroSection_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: heroSectionData?.description
                            }
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HeroSection_module_default())["feature-container"],
                            children: heroSectionData?.feature?.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HeroSection_module_default()).feature,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSection_module_default())["icon-container"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: feature?.icon?.url ?? "",
                                                height: 20,
                                                width: 20,
                                                alt: feature?.icon?.name ?? "icon.webp"
                                            })
                                        }),
                                        feature?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSection_module_default())["feature-title"],
                                            dangerouslySetInnerHTML: {
                                                __html: feature.title
                                            }
                                        })
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HeroSection_module_default())["button-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ctaBtnClickHandler(applyCtaButtonProps),
                                    className: applyCtaButtonProps.formClassName,
                                    children: heroSectionData?.button?.title || "Partner with us"
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HeroSection_module_default())["feature-container-mobile-wrapper"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroSection_module_default())["feature-container-mobile"],
                                        children: heroSectionData?.feature?.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (HeroSection_module_default()).feature,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (HeroSection_module_default())["icon-container"],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: feature?.icon?.url ?? "",
                                                            height: 20,
                                                            width: 20,
                                                            alt: feature?.icon?.name ?? "icon.webp"
                                                        })
                                                    }),
                                                    feature?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (HeroSection_module_default())["feature-title"],
                                                        dangerouslySetInnerHTML: {
                                                            __html: feature.title
                                                        }
                                                    })
                                                ]
                                            }))
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__(89382);
;// CONCATENATED MODULE: ./node_modules/embla-carousel-auto-scroll/esm/embla-carousel-auto-scroll.esm.js
const defaultOptions = {
  direction: 'forward',
  speed: 2,
  startDelay: 1000,
  active: true,
  breakpoints: {},
  playOnInit: true,
  stopOnFocusIn: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  rootNode: null
};

function getAutoScrollRootNode(emblaApi, rootNode) {
  const emblaRootNode = emblaApi.rootNode();
  return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}

function AutoScroll(userOptions = {}) {
  let options;
  let emblaApi;
  let destroyed;
  let startDelay;
  let timerId = 0;
  let autoScrollActive = false;
  let mouseIsOver = false;
  let defaultScrollBehaviour;
  function init(emblaApiInstance, optionsHandler) {
    emblaApi = emblaApiInstance;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, AutoScroll.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    if (emblaApi.scrollSnapList().length <= 1) return;
    startDelay = options.startDelay;
    destroyed = false;
    defaultScrollBehaviour = emblaApi.internalEngine().scrollBody;
    const {
      eventStore
    } = emblaApi.internalEngine();
    const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
    const root = getAutoScrollRootNode(emblaApi, options.rootNode);
    if (isDraggable) {
      emblaApi.on('pointerDown', pointerDown);
    }
    if (isDraggable && !options.stopOnInteraction) {
      emblaApi.on('pointerUp', pointerUp);
    }
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', mouseEnter);
    }
    if (options.stopOnMouseEnter && !options.stopOnInteraction) {
      eventStore.add(root, 'mouseleave', mouseLeave);
    }
    if (options.stopOnFocusIn) {
      emblaApi.on('slideFocusStart', stopAutoScroll);
    }
    if (options.stopOnFocusIn && !options.stopOnInteraction) {
      eventStore.add(emblaApi.containerNode(), 'focusout', startAutoScroll);
    }
    if (options.playOnInit) startAutoScroll();
  }
  function destroy() {
    emblaApi.off('pointerDown', pointerDown).off('pointerUp', pointerUp).off('slideFocusStart', stopAutoScroll).off('settle', settle);
    stopAutoScroll();
    destroyed = true;
    autoScrollActive = false;
  }
  function startAutoScroll() {
    if (destroyed) return;
    if (autoScrollActive) return;
    emblaApi.emit('autoScroll:play');
    const engine = emblaApi.internalEngine();
    const {
      ownerWindow
    } = engine;
    timerId = ownerWindow.setTimeout(() => {
      engine.scrollBody = createAutoScrollBehaviour(engine);
      engine.animation.start();
    }, startDelay);
    autoScrollActive = true;
  }
  function stopAutoScroll() {
    if (destroyed) return;
    if (!autoScrollActive) return;
    emblaApi.emit('autoScroll:stop');
    const engine = emblaApi.internalEngine();
    const {
      ownerWindow
    } = engine;
    engine.scrollBody = defaultScrollBehaviour;
    ownerWindow.clearTimeout(timerId);
    timerId = 0;
    autoScrollActive = false;
  }
  function createAutoScrollBehaviour(engine) {
    const {
      location,
      previousLocation,
      offsetLocation,
      target,
      scrollTarget,
      index,
      indexPrevious,
      limit: {
        reachedMin,
        reachedMax,
        constrain
      },
      options: {
        loop
      }
    } = engine;
    const directionSign = options.direction === 'forward' ? -1 : 1;
    const noop = () => self;
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    let hasSettled = false;
    function seek() {
      let directionDiff = 0;
      previousLocation.set(location);
      bodyVelocity = directionSign * options.speed;
      rawLocation += bodyVelocity;
      location.add(bodyVelocity);
      target.set(location);
      directionDiff = rawLocation - rawLocationPrevious;
      scrollDirection = Math.sign(directionDiff);
      rawLocationPrevious = rawLocation;
      const currentIndex = scrollTarget.byDistance(0, false).index;
      if (index.get() !== currentIndex) {
        indexPrevious.set(index.get());
        index.set(currentIndex);
        emblaApi.emit('select');
      }
      const reachedEnd = options.direction === 'forward' ? reachedMin(offsetLocation.get()) : reachedMax(offsetLocation.get());
      if (!loop && reachedEnd) {
        hasSettled = true;
        const constrainedLocation = constrain(location.get());
        location.set(constrainedLocation);
        target.set(location);
        stopAutoScroll();
      }
      return self;
    }
    const self = {
      direction: () => scrollDirection,
      duration: () => -1,
      velocity: () => bodyVelocity,
      settled: () => hasSettled,
      seek,
      useBaseFriction: noop,
      useBaseDuration: noop,
      useFriction: noop,
      useDuration: noop
    };
    return self;
  }
  function pointerDown() {
    if (!mouseIsOver) stopAutoScroll();
  }
  function pointerUp() {
    if (!mouseIsOver) startAutoScrollOnSettle();
  }
  function mouseEnter() {
    mouseIsOver = true;
    stopAutoScroll();
  }
  function mouseLeave() {
    mouseIsOver = false;
    startAutoScroll();
  }
  function settle() {
    emblaApi.off('settle', settle);
    startAutoScroll();
  }
  function startAutoScrollOnSettle() {
    emblaApi.on('settle', settle);
  }
  function play(startDelayOverride) {
    if (typeof startDelayOverride !== 'undefined') {
      startDelay = startDelayOverride;
    }
    startAutoScroll();
  }
  function stop() {
    if (autoScrollActive) stopAutoScroll();
  }
  function reset() {
    if (autoScrollActive) {
      stopAutoScroll();
      startAutoScrollOnSettle();
    }
  }
  function isPlaying() {
    return autoScrollActive;
  }
  const self = {
    name: 'autoScroll',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset,
    isPlaying
  };
  return self;
}
AutoScroll.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-auto-scroll.esm.js.map

// EXTERNAL MODULE: ./components/PartnerCountry/Tieups/Tieups.module.scss
var Tieups_module = __webpack_require__(80451);
var Tieups_module_default = /*#__PURE__*/__webpack_require__.n(Tieups_module);
// EXTERNAL MODULE: ./utils/constants.ts
var utils_constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./components/PartnerCountry/Tieups/Tieups.tsx








const MIN_MARQUEE_ITEMS = 8;
const MARQUEE_CENTER_THRESHOLD = 6;
const MARQUEE_CENTER_THRESHOLD_MOBILE = 2;
const hasLogo = (university)=>Boolean(university.universityLogo?.imageUrl);
const buildMarqueeTrack = (universities, centerThreshold)=>{
    const withLogo = universities.filter(hasLogo);
    if (withLogo.length <= centerThreshold) return withLogo;
    const repeated = [];
    while(repeated.length < MIN_MARQUEE_ITEMS){
        repeated.push(...withLogo);
    }
    return repeated;
};
const MARQUEE_SPEED = 1;
const MARQUEE_RESUME_DELAY = 200;
const COUNTRY_NAME_ALIASES = {
    "united states": "USA",
    "united states of america": "USA",
    uk: "UnitedKingdom"
};
const getCountrySlug = (countryName)=>{
    if (!countryName) return undefined;
    const normalized = countryName.trim().toLowerCase();
    const aliased = COUNTRY_NAME_ALIASES[normalized] ?? countryName;
    return utils_constants/* countries.find */.hW.find((country)=>country.value.toLowerCase() === aliased.toLowerCase())?.slug;
};
const getUniversityUrl = (university)=>{
    const countrySlug = getCountrySlug(university.country ?? undefined);
    if (university.slug && countrySlug) return `/universities/${countrySlug}/${university.slug}`;
    return university.universityUrl ?? undefined;
};
const MarqueeRow = ({ trackKey , universities , direction , isMobile  })=>{
    const isCentered = universities.length <= (isMobile ? MARQUEE_CENTER_THRESHOLD_MOBILE : MARQUEE_CENTER_THRESHOLD);
    const autoScroll = (0,react.useRef)(AutoScroll({
        speed: MARQUEE_SPEED,
        direction,
        startDelay: MARQUEE_RESUME_DELAY,
        stopOnInteraction: false,
        stopOnMouseEnter: true
    }));
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: !isCentered,
        dragFree: !isCentered,
        align: isCentered ? "center" : "start"
    }, isCentered ? [] : [
        autoScroll.current
    ]);
    (0,react.useEffect)(()=>{
        emblaApi?.reInit();
    }, [
        emblaApi,
        trackKey
    ]);
    if (!universities.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(Tieups_module_default())["marquee-row"]}${isCentered ? ` ${(Tieups_module_default())["marquee-row--single"]}` : ""}`,
        ref: emblaRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${(Tieups_module_default())["marquee-track"]}${isCentered ? ` ${(Tieups_module_default())["marquee-track--single"]}` : ""}`,
            children: universities.map((university, index)=>{
                const url = getUniversityUrl(university);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Tieups_module_default())["marquee-slide"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (Tieups_module_default())["logo-card"],
                        onClick: ()=>url && window.open(url, "_blank"),
                        disabled: !url,
                        "aria-label": university.name,
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: university.universityLogo.imageUrl,
                            alt: university.name,
                            width: 110,
                            height: 52,
                            layout: "fixed",
                            objectFit: "contain"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: university.universityLogo.imageUrl,
                            alt: university.name,
                            width: 240,
                            height: 115,
                            layout: "fixed",
                            objectFit: "contain"
                        })
                    })
                }, `${university.id}-${index}`);
            })
        })
    });
};
const Tieups = ({ tieupsData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const countries = tieupsData?.countries?.filter((country)=>(country?.universities_row_1?.length ?? 0) > 0 || (country?.universities_row_2?.length ?? 0) > 0) ?? [];
    const { 0: activeCountryId , 1: setActiveCountryId  } = (0,react.useState)(countries[0]?.id);
    const activeCountry = countries.find((country)=>country.id === activeCountryId) ?? countries[0];
    const marqueeCenterThreshold = isMobile ? MARQUEE_CENTER_THRESHOLD_MOBILE : MARQUEE_CENTER_THRESHOLD;
    const row1 = buildMarqueeTrack(activeCountry?.universities_row_1 ?? [], marqueeCenterThreshold);
    const row2 = buildMarqueeTrack(activeCountry?.universities_row_2 ?? [], marqueeCenterThreshold);
    if (!tieupsData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Tieups_module_default())["tie-ups-container"],
        children: [
            tieupsData.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Tieups_module_default()).heading,
                children: tieupsData.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tieups_module_default())["pill-row"],
                children: countries?.length > 0 && countries.map((country)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        "aria-pressed": activeCountryId === country?.id,
                        className: `${(Tieups_module_default()).pill} ${activeCountryId === country?.id ? (Tieups_module_default())["pill-active"] : ""}`,
                        onClick: ()=>setActiveCountryId(country?.id),
                        children: [
                            country?.flagImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: country?.flagImg.url,
                                alt: country?.name,
                                width: 20,
                                height: 14
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: country?.name
                            })
                        ]
                    }, country.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Tieups_module_default())["marquee-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarqueeRow, {
                        trackKey: `${activeCountry?.id}-row1`,
                        universities: row1,
                        direction: "forward",
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarqueeRow, {
                        trackKey: `${activeCountry?.id}-row2`,
                        universities: row2,
                        direction: "backward",
                        isMobile: isMobile
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tieups_Tieups = (Tieups);

// EXTERNAL MODULE: ./components/PartnerCountry/ProductFeatures/ProductFeatures.module.scss
var ProductFeatures_module = __webpack_require__(47566);
var ProductFeatures_module_default = /*#__PURE__*/__webpack_require__.n(ProductFeatures_module);
;// CONCATENATED MODULE: ./components/UI/Icons/PlayIcon.tsx


const PlayIcon = ({ width =18 , height =18 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 11 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.95644 7.7836C11.2795 7.01185 11.2795 5.10024 9.95644 4.32849L3.00765 0.275024C1.67433 -0.502743 -9.54522e-05 0.458999 -9.55196e-05 2.00258L-9.5874e-05 10.1095C-9.59415e-05 11.6531 1.67433 12.6148 3.00765 11.8371L9.95644 7.7836Z",
            fill: color
        })
    });
};
/* harmony default export */ var Icons_PlayIcon = (PlayIcon);

// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/PartnerCountry/ProductFeatures/ProductFeatures.tsx











const ProductFeatures = ({ productFeaturesData  })=>{
    const router = (0,next_router.useRouter)();
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    const { 0: hasStartedVideo , 1: setHasStartedVideo  } = (0,react.useState)(false);
    const { 0: isVideoPlaying , 1: setIsVideoPlaying  } = (0,react.useState)(false);
    const videoIframeRef = (0,react.useRef)(null);
    if (!productFeaturesData) return null;
    const { title , description , videoLink , videoThumbnail , button , card , featureHeading  } = productFeaturesData;
    const videoId = (0,helpers/* getYouTubeVideoId */.Ei)(videoLink);
    const videoEmbedUrl = (0,helpers/* convertYouTubeToEmbed */.gE)(videoLink);
    const videoPosterUrl = videoThumbnail?.url || (videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : "");
    const videoAutoplaySrc = videoEmbedUrl ? `${videoEmbedUrl}${videoEmbedUrl.includes("?") ? "&" : "?"}autoplay=1&enablejsapi=1` : "";
    (0,react.useEffect)(()=>{
        if (!hasStartedVideo) return;
        const handleMessage = (event)=>{
            if (event.origin !== "https://www.youtube.com") return;
            let data;
            try {
                data = JSON.parse(event.data);
            } catch  {
                return;
            }
            const playerState = data?.info?.playerState;
            if (data?.event !== "infoDelivery" || playerState === undefined) return;
            if (playerState === 1) {
                setIsVideoPlaying(true);
            } else if (playerState === 0 || playerState === 2) {
                setIsVideoPlaying(false);
            }
        };
        window.addEventListener("message", handleMessage);
        return ()=>window.removeEventListener("message", handleMessage);
    }, [
        hasStartedVideo
    ]);
    const handleVideoIframeLoad = ()=>{
        videoIframeRef.current?.contentWindow?.postMessage(JSON.stringify({
            event: "listening",
            id: videoId
        }), "https://www.youtube.com");
    };
    const ctaProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: button?.link,
        formId: button?.formId,
        toOnboardingEnabled: button?.toOnboardingEnabled ?? undefined,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const handleProductFeaturesCtaClick = (e)=>{
        if (ctaProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: button?.nearestOffice ?? true,
                coachingVisible: button?.lookingForCoaching ?? true
            });
        }
        ctaProps.onClick?.(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ProductFeatures_module_default())["product-features-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductFeatures_module_default()).intro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductFeatures_module_default())["intro-content"],
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductFeatures_module_default()).heading,
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductFeatures_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            }),
                            button?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: `${(ProductFeatures_module_default())["cta-button"]} ${ctaProps.formClassName ?? ""}`.trim(),
                                onClick: handleProductFeaturesCtaClick,
                                children: button.title
                            })
                        ]
                    }),
                    videoLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductFeatures_module_default()).media,
                        children: [
                            !isVideoPlaying && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProductFeatures_module_default())["left-img-container"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: productFeaturesData?.leftCardImg?.url ?? "",
                                            height: isMobile ? 85 : 176,
                                            width: isMobile ? 85 : 176,
                                            alt: productFeaturesData?.leftCardImg?.name ?? ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProductFeatures_module_default())["right-img-container"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: productFeaturesData?.rightCardImg?.url ?? "",
                                            height: isMobile ? 94 : 194,
                                            width: isMobile ? 73 : 151,
                                            alt: productFeaturesData?.rightCardImg?.name ?? ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProductFeatures_module_default())["shadow-layer"]
                            }),
                            videoLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductFeatures_module_default())["video-frame"],
                                children: [
                                    hasStartedVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        ref: videoIframeRef,
                                        className: (ProductFeatures_module_default()).video,
                                        src: videoAutoplaySrc,
                                        title: title || "Product video",
                                        style: {
                                            border: 0
                                        },
                                        allow: "autoplay; encrypted-media; picture-in-picture",
                                        allowFullScreen: true,
                                        onLoad: handleVideoIframeLoad
                                    }),
                                    !hasStartedVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            videoPosterUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (ProductFeatures_module_default()).video,
                                                src: videoPosterUrl,
                                                alt: videoThumbnail?.alternativeText || videoThumbnail?.name || title || "Product video",
                                                onClick: ()=>{
                                                    setHasStartedVideo(true);
                                                    setIsVideoPlaying(true);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ProductFeatures_module_default())["outer-radius"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: (ProductFeatures_module_default())["play-button"],
                                                    onClick: ()=>{
                                                        setHasStartedVideo(true);
                                                        setIsVideoPlaying(true);
                                                    },
                                                    "aria-label": "Play video",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PlayIcon, {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            card?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductFeatures_module_default())["grid-section"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (ProductFeatures_module_default())["grid-heading"],
                        children: featureHeading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductFeatures_module_default())["card-grid"],
                        children: card.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductFeatures_module_default()).card,
                                children: [
                                    item.highlightImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProductFeatures_module_default())["card-image-wrapper"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: item.highlightImg.url,
                                            alt: item.highlightImg.alternativeText || item.title,
                                            layout: "responsive",
                                            width: 325,
                                            height: 252,
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ProductFeatures_module_default())["card-content"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (ProductFeatures_module_default())["card-title"],
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (ProductFeatures_module_default())["card-description"],
                                                children: item.description
                                            })
                                        ]
                                    })
                                ]
                            }, item.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductFeatures_ProductFeatures = (ProductFeatures);

// EXTERNAL MODULE: ./components/PartnerCountry/WhyKc/WhyKc.module.scss
var WhyKc_module = __webpack_require__(49733);
var WhyKc_module_default = /*#__PURE__*/__webpack_require__.n(WhyKc_module);
;// CONCATENATED MODULE: ./components/UI/Icons/ThreeCircles.tsx


const ThreeCircles = ({ width =355 , height =356 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 355 356",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_15781_119)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "path-1-inside-1_15781_119",
                        fill: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 43.3086C0 -129.28 139.911 -269.191 312.5 -269.191V-269.191C485.089 -269.191 625 -129.28 625 43.3086V43.3086C625 215.898 485.089 355.809 312.5 355.809V355.809C139.911 355.809 0 215.898 0 43.3086V43.3086Z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 43.3086M625 43.3086M625 43.3086M0 43.3086M312.5 -269.191M625 43.3086M312.5 355.809M0 43.3086M312.5 355.809V354.809C140.463 354.809 1 215.345 1 43.3086H0H-1C-1 216.45 139.359 356.809 312.5 356.809V355.809ZM625 43.3086H624C624 215.345 484.537 354.809 312.5 354.809V355.809V356.809C485.641 356.809 626 216.45 626 43.3086H625ZM312.5 -269.191V-268.191C484.537 -268.191 624 -128.728 624 43.3086H625H626C626 -129.833 485.641 -270.191 312.5 -270.191V-269.191ZM312.5 -269.191V-270.191C139.359 -270.191 -1 -129.833 -1 43.3086H0H1C1 -128.728 140.463 -268.191 312.5 -268.191V-269.191Z",
                        fill: "#6C48F0",
                        mask: "url(#path-1-inside-1_15781_119)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "path-3-inside-2_15781_119",
                        fill: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M105 43.8086C105 -70.7905 197.901 -164.191 312.5 -164.191V-164.191C427.099 -164.191 520 -70.7905 520 43.8086V43.8086C520 158.408 427.099 251.809 312.5 251.809V251.809C197.901 251.809 105 158.408 105 43.8086V43.8086Z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M105 43.8086M520 43.8086M520 43.8086M105 43.8086M312.5 -164.191M520 43.8086M312.5 251.809M105 43.8086M312.5 251.809V250.809C198.456 250.809 106 157.859 106 43.8086H105H104C104 158.957 197.346 252.809 312.5 252.809V251.809ZM520 43.8086H519C519 157.859 426.544 250.809 312.5 250.809V251.809V252.809C427.655 252.809 521 158.957 521 43.8086H520ZM312.5 -164.191V-163.191C426.544 -163.191 519 -70.2413 519 43.8086H520H521C521 -71.3396 427.655 -165.191 312.5 -165.191V-164.191ZM312.5 -164.191V-165.191C197.346 -165.191 104 -71.3396 104 43.8086H105H106C106 -70.2413 198.456 -163.191 312.5 -163.191V-164.191Z",
                        fill: "#6C48F0",
                        mask: "url(#path-3-inside-2_15781_119)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "path-5-inside-3_15781_119",
                        fill: "white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M216 43.8086C216 -9.48688 259.205 -53.1914 312.5 -53.1914V-53.1914C365.795 -53.1914 409 -9.48688 409 43.8086V43.8086C409 97.1041 365.795 140.809 312.5 140.809V140.809C259.205 140.809 216 97.1041 216 43.8086V43.8086Z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M216 43.8086M409 43.8086M409 43.8086M216 43.8086M312.5 -53.1914M409 43.8086M312.5 140.809M216 43.8086M312.5 140.809V139.809C259.764 139.809 217 96.5585 217 43.8086H216H215C215 97.6496 258.646 141.809 312.5 141.809V140.809ZM409 43.8086H408C408 96.5585 365.236 139.809 312.5 139.809V140.809V141.809C366.354 141.809 410 97.6496 410 43.8086H409ZM312.5 -53.1914V-52.1914C365.236 -52.1914 408 -8.94133 408 43.8086H409H410C410 -10.0324 366.354 -54.1914 312.5 -54.1914V-53.1914ZM312.5 -53.1914V-54.1914C258.646 -54.1914 215 -10.0324 215 43.8086H216H217C217 -8.94133 259.764 -52.1914 312.5 -52.1914V-53.1914Z",
                        fill: "#6C48F0",
                        mask: "url(#path-5-inside-3_15781_119)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_15781_119",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "355",
                        height: "356",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ThreeCircles = (ThreeCircles);

;// CONCATENATED MODULE: ./components/PartnerCountry/WhyKc/WhyKc.tsx






const WhyKc = ({ whyKcData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1024);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (WhyKc_module_default())["why-kc-container"],
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WhyKc_module_default())["circle-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ThreeCircles, {})
            }),
            whyKcData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (WhyKc_module_default()).heading,
                dangerouslySetInnerHTML: {
                    __html: isMobile ? whyKcData?.mobileTitle : whyKcData?.title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WhyKc_module_default())["card-grid"],
                children: [
                    whyKcData?.card && whyKcData?.card?.length > 0 && whyKcData.card.map((card)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (WhyKc_module_default()).card,
                            children: [
                                card?.highlightImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (WhyKc_module_default()).badge,
                                    style: {
                                        background: card?.iconBgColor ?? ""
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: card?.highlightImg?.url ?? "",
                                        alt: card?.highlightImg?.name ?? "highlight.webp",
                                        height: 24,
                                        width: 24
                                    })
                                }),
                                card.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (WhyKc_module_default())["card-title"],
                                    children: card.title
                                }),
                                card.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (WhyKc_module_default())["card-description"],
                                    children: card.description
                                })
                            ]
                        }, card.id);
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (WhyKc_module_default())["gradient-layer"]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WhyKc_WhyKc = (WhyKc);

// EXTERNAL MODULE: ./components/PartnerCountry/Testimonies/Testimonies.module.scss
var Testimonies_module = __webpack_require__(83179);
var Testimonies_module_default = /*#__PURE__*/__webpack_require__.n(Testimonies_module);
;// CONCATENATED MODULE: ./components/UI/Icons/Quote.tsx


const Quote = ({ width =42 , height =28 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 42 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.53809 28.002C4.28637 28.0017 0.0292972 23.7439 0.0292977 18.4922C0.0293034 18.3695 0.0334786 18.2475 0.0380868 18.126L0.0273446 18.1387C-0.324853 13.2959 2.63367 2.88803 17.2852 -1.541e-07C14.481 1.41594 8.68087 5.18169 6.75 9.40039C7.63186 9.13026 8.56775 8.98344 9.53809 8.9834C14.7898 8.9834 19.0476 13.2405 19.0479 18.4922C19.0479 23.7441 14.79 28.002 9.53809 28.002Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.4746 28.002C27.2229 28.0017 22.9658 23.7439 22.9658 18.4922C22.9658 18.3702 22.9701 18.2488 22.9746 18.1279L22.9639 18.1406C22.6117 13.2979 25.5702 2.88999 40.2217 0.00195297C37.418 1.41768 31.6193 5.18249 29.6875 9.40039C30.5691 9.13044 31.5046 8.98344 32.4746 8.9834C37.7264 8.9834 41.9842 13.2405 41.9844 18.4922C41.9844 23.7441 37.7265 28.002 32.4746 28.002Z",
                fill: color
            })
        ]
    });
};
/* harmony default export */ var Icons_Quote = (Quote);

// EXTERNAL MODULE: ./components/UI/Modal/Modal.tsx
var Modal = __webpack_require__(98188);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
;// CONCATENATED MODULE: ./components/PartnerCountry/Testimonies/Testimonies.tsx











// The design hides the play button on the second slide regardless of whether that testimony has a videoLink.
const PLAY_BUTTON_HIDDEN_INDEX = 1;
const AUTO_FLIP_DELAY_MS = 500;
const TestimonyCard = ({ testimony , index , onPlayClick , onOpenVideoModal , isMobile , isActive  })=>{
    const { 0: isFlipped , 1: setIsFlipped  } = (0,react.useState)(()=>!isMobile && index === 0);
    (0,react.useEffect)(()=>{
        if (!isMobile) return;
        if (!isActive) {
            setIsFlipped(false);
            return;
        }
        const timer = setTimeout(()=>setIsFlipped(true), AUTO_FLIP_DELAY_MS);
        return ()=>clearTimeout(timer);
    }, [
        isActive,
        isMobile
    ]);
    const handleFrontPlayClick = (e)=>{
        e.stopPropagation();
        if (testimony.videoLink) onPlayClick?.(testimony.videoLink);
    };
    const handleBackPlayClick = (e)=>{
        e.stopPropagation();
        if (testimony.videoLink) onOpenVideoModal(testimony.videoLink);
    };
    const renderPlayButton = ({ theme ="white" , onClick  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: theme === "golden" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Testimonies_module_default())["outer-radius"],
                style: {
                    background: "#ffffff45"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (Testimonies_module_default())["play-button"],
                    onClick: onClick,
                    "aria-label": `Play ${testimony.name}'s testimony video`,
                    style: {
                        backgroundColor: "#ffffff"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PlayIcon, {
                        color: "#F5A623",
                        width: isMobile ? 10 : 16,
                        height: isMobile ? 10 : 16
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Testimonies_module_default())["outer-radius"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (Testimonies_module_default())["play-button"],
                    onClick: onClick,
                    "aria-label": `Play ${testimony.name}'s testimony video`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PlayIcon, {
                        color: "#ffffff",
                        width: isMobile ? 10 : 15,
                        height: isMobile ? 10 : 15
                    })
                })
            })
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(Testimonies_module_default())["flip-card"]} ${isFlipped ? (Testimonies_module_default())["flip-card--flipped"] : ""}`.trim(),
        onMouseEnter: ()=>setIsFlipped(true),
        onMouseLeave: ()=>setIsFlipped(false),
        onClick: ()=>setIsFlipped((prev)=>!prev),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Testimonies_module_default())["flip-card-inner"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Testimonies_module_default())["flip-card-front"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonies_module_default())["flip-card-overlay"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: testimony.profileImg?.url ?? "",
                            alt: testimony.profileImg?.name ?? testimony.name,
                            layout: "fill",
                            objectFit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Testimonies_module_default())["front-overlay"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Testimonies_module_default())["testimony-name"],
                                            children: testimony.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Testimonies_module_default())["testimony-designation"],
                                            dangerouslySetInnerHTML: {
                                                __html: testimony.designation
                                            }
                                        })
                                    ]
                                }),
                                testimony.videoLink && renderPlayButton({
                                    theme: "golden",
                                    onClick: handleFrontPlayClick
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Testimonies_module_default())["flip-card-back"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Quote, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonies_module_default())["testimony-statement"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Testimonies_module_default())["testimony-statement-text"],
                                dangerouslySetInnerHTML: {
                                    __html: testimony.statement
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Testimonies_module_default())["back-footer"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Testimonies_module_default())["testimony-name"],
                                            children: testimony.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Testimonies_module_default())["testimony-designation"],
                                            dangerouslySetInnerHTML: {
                                                __html: testimony.designation
                                            }
                                        })
                                    ]
                                }),
                                testimony.videoLink && renderPlayButton({
                                    theme: "white",
                                    onClick: handleBackPlayClick
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const Testimonies = ({ testimoniesData , onPlayClick  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(1024);
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: false,
        align: "start"
    });
    const { 0: canScrollPrev , 1: setCanScrollPrev  } = (0,react.useState)(false);
    const { 0: canScrollNext , 1: setCanScrollNext  } = (0,react.useState)(false);
    const { 0: hasOverflow , 1: setHasOverflow  } = (0,react.useState)(true);
    const { 0: activeVideoLink , 1: setActiveVideoLink  } = (0,react.useState)(null);
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react.useState)(0);
    const { 0: isSectionInView , 1: setIsSectionInView  } = (0,react.useState)(false);
    const sectionRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const node = sectionRef.current;
        if (!node) return;
        const observer = new IntersectionObserver(([entry])=>setIsSectionInView(entry.isIntersecting), {
            threshold: 0.3
        });
        observer.observe(node);
        return ()=>observer.disconnect();
    }, []);
    (0,react.useEffect)(()=>{
        if (!emblaApi) return;
        const updateScrollState = ()=>{
            setCanScrollPrev(emblaApi.canScrollPrev());
            setCanScrollNext(emblaApi.canScrollNext());
            setHasOverflow(emblaApi.canScrollPrev() || emblaApi.canScrollNext());
            setActiveIndex(emblaApi.selectedScrollSnap());
        };
        updateScrollState();
        emblaApi.on("select", updateScrollState);
        emblaApi.on("reInit", updateScrollState);
        emblaApi.on("resize", updateScrollState);
        return ()=>{
            emblaApi.off("select", updateScrollState);
            emblaApi.off("reInit", updateScrollState);
            emblaApi.off("resize", updateScrollState);
        };
    }, [
        emblaApi,
        testimoniesData
    ]);
    if (!testimoniesData) return null;
    const { title , testimony  } = testimoniesData;
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    const closeVideoModal = ()=>setActiveVideoLink(null);
    const activeVideoEmbedUrl = (()=>{
        const embedUrl = (0,helpers/* convertYouTubeToEmbed */.gE)(activeVideoLink);
        if (!embedUrl) return null;
        return `${embedUrl}${embedUrl.includes("?") ? "&" : "?"}autoplay=1`;
    })();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: sectionRef,
        className: (Testimonies_module_default())["testimonies-container"],
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Testimonies_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Testimonies_module_default())["carousel-wrapper"],
                children: [
                    !isMobile && hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: `${(Testimonies_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Testimonies_module_default())["btcircle-disabled"]}`} ${(Testimonies_module_default()).btnCircleLeft}`,
                        onClick: canScrollPrev ? goToPrev : undefined,
                        "aria-disabled": !canScrollPrev,
                        "aria-label": "Previous testimonial",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            width: 14,
                            height: 14
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Testimonies_module_default()).viewport,
                        ref: emblaRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(Testimonies_module_default())["slider-container"]}${hasOverflow ? "" : ` ${(Testimonies_module_default())["slider-container--centered"]}`}`,
                            children: testimony?.length > 0 && testimony?.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Testimonies_module_default()).slide,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonyCard, {
                                        testimony: item,
                                        index: index,
                                        onPlayClick: onPlayClick,
                                        onOpenVideoModal: setActiveVideoLink,
                                        isMobile: isMobile,
                                        isActive: isMobile && index === activeIndex && isSectionInView
                                    })
                                }, item.id))
                        })
                    }),
                    !isMobile && hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: `${(Testimonies_module_default()).btcircle}${canScrollNext ? "" : ` ${(Testimonies_module_default())["btcircle-disabled"]}`}`,
                        onClick: canScrollNext ? goToNext : undefined,
                        "aria-disabled": !canScrollNext,
                        "aria-label": "Next testimonial",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            width: 14,
                            height: 14
                        })
                    }),
                    isMobile && hasOverflow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Testimonies_module_default())["nav-arrows"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: `${(Testimonies_module_default()).btcircle}${canScrollPrev ? "" : ` ${(Testimonies_module_default())["btcircle-disabled"]}`} ${(Testimonies_module_default()).btnCircleLeft}`,
                                onClick: canScrollPrev ? goToPrev : undefined,
                                "aria-disabled": !canScrollPrev,
                                "aria-label": "Previous testimonial",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                    width: 14,
                                    height: 14
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: `${(Testimonies_module_default()).btcircle}${canScrollNext ? "" : ` ${(Testimonies_module_default())["btcircle-disabled"]}`}`,
                                onClick: canScrollNext ? goToNext : undefined,
                                "aria-disabled": !canScrollNext,
                                "aria-label": "Next testimonial",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                    width: 14,
                                    height: 14
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isOpen: !!activeVideoLink,
                onClose: closeVideoModal,
                contentClassName: (Testimonies_module_default())["video-modal-container"],
                children: activeVideoEmbedUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: activeVideoEmbedUrl,
                    className: (Testimonies_module_default())["modal-video"],
                    title: "Testimonial video",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true
                })
            })
        ]
    });
};
/* harmony default export */ var Testimonies_Testimonies = (Testimonies);

// EXTERNAL MODULE: ./components/PartnerCountry/HowToBecomePartner/HowToBecomePartner.module.scss
var HowToBecomePartner_module = __webpack_require__(59515);
var HowToBecomePartner_module_default = /*#__PURE__*/__webpack_require__.n(HowToBecomePartner_module);
;// CONCATENATED MODULE: ./components/PartnerCountry/HowToBecomePartner/HowToBecomePartner.tsx





const HowToBecomePartner = ({ howToBecomePartnerData  })=>{
    if (!howToBecomePartnerData) return null;
    const { title , description , card: cards  } = howToBecomePartnerData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (HowToBecomePartner_module_default())["how-to-become-partner-container"],
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (HowToBecomePartner_module_default()).heading,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowToBecomePartner_module_default()).subtext,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowToBecomePartner_module_default())["steps-row"],
                children: cards?.length > 0 && cards.map((card, index)=>{
                    const isLastCard = index === cards.length - 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowToBecomePartner_module_default()).card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (HowToBecomePartner_module_default())["step-number"],
                                        children: String(index + 1).padStart(2, "0")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(HowToBecomePartner_module_default())["illustration-box"]}`,
                                        children: card.highlightImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: card.highlightImg.url,
                                            alt: card.highlightImg.alternativeText || card.title,
                                            width: 349,
                                            height: 208,
                                            objectFit: "contain"
                                        })
                                    }),
                                    card.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (HowToBecomePartner_module_default())["card-title"],
                                        children: card.title
                                    }),
                                    card.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HowToBecomePartner_module_default())["card-description"],
                                        children: card.description
                                    })
                                ]
                            }),
                            !isLastCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HowToBecomePartner_module_default()).connector,
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HowToBecomePartner_module_default())["connector-icon-desktop"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                            width: 16,
                                            height: 16,
                                            color: "#ffffff"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HowToBecomePartner_module_default())["connector-icon-mobile"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                            width: 16,
                                            height: 16,
                                            color: "#ffffff"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, card.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HowToBecomePartner_HowToBecomePartner = (HowToBecomePartner);

// EXTERNAL MODULE: ./components/PartnerCountry/ConnectWithTeam/ConnectWithTeam.module.scss
var ConnectWithTeam_module = __webpack_require__(60508);
var ConnectWithTeam_module_default = /*#__PURE__*/__webpack_require__.n(ConnectWithTeam_module);
// EXTERNAL MODULE: ./components/UI/Icons/Mail.tsx
var Mail = __webpack_require__(68613);
;// CONCATENATED MODULE: ./components/UI/Icons/Whatsapp.tsx


const Whatsapp = ({ width =14 , height =14 , color ="#ffffff"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.601 2.326A7.854 7.854 0 0 0 8.014 0C3.634 0 .073 3.562.072 7.943a7.935 7.935 0 0 0 1.06 3.965L0 16l4.194-1.1a7.93 7.93 0 0 0 3.808.968h.003c4.38 0 7.941-3.562 7.943-7.943a7.898 7.898 0 0 0-2.347-5.6zM8.005 14.5h-.003a6.55 6.55 0 0 1-3.339-.914l-.24-.142-2.489.653.664-2.425-.156-.249a6.542 6.542 0 0 1-1.003-3.48c0-3.622 2.949-6.571 6.573-6.571a6.53 6.53 0 0 1 4.649 1.926 6.53 6.53 0 0 1 1.923 4.652c-.001 3.623-2.95 6.55-6.579 6.55zm3.607-4.926c-.198-.099-1.17-.578-1.352-.644-.181-.066-.313-.099-.445.099-.132.198-.512.644-.627.777-.115.132-.231.148-.429.05-.198-.099-.836-.308-1.593-.984-.589-.525-.987-1.174-1.103-1.372-.115-.198-.012-.305.087-.404.089-.089.198-.231.297-.347.099-.115.132-.198.198-.33.066-.132.033-.248-.017-.347-.05-.099-.445-1.073-.610-1.469-.161-.386-.324-.334-.445-.34a8.53 8.53 0 0 0-.379-.007.728.728 0 0 0-.529.248c-.181.198-.693.677-.693 1.652s.71 1.917.808 2.049c.099.132 1.394 2.128 3.377 2.984.472.204.84.325 1.127.416.473.15.903.129 1.243.078.379-.057 1.17-.478 1.335-.94.165-.462.165-.858.116-.94-.05-.083-.181-.132-.379-.231z",
            fill: color
        })
    });
};
/* harmony default export */ var Icons_Whatsapp = (Whatsapp);

;// CONCATENATED MODULE: ./components/UI/Icons/PhoneDarker.tsx


const PhoneDarker = ({ width =14 , height =14 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5001 12.6901V14.9401C16.5009 15.149 16.4581 15.3557 16.3745 15.5471C16.2908 15.7385 16.168 15.9103 16.0141 16.0515C15.8602 16.1927 15.6785 16.3002 15.4806 16.3671C15.2828 16.434 15.0731 16.4589 14.8651 16.4401C12.5572 16.1893 10.3403 15.4007 8.39257 14.1376C6.58044 12.9861 5.04407 11.4497 3.89257 9.63757C2.62506 7.68098 1.83625 5.45332 1.59007 3.13507C1.57133 2.92767 1.59598 2.71864 1.66245 2.52129C1.72892 2.32394 1.83575 2.14259 1.97615 1.98879C2.11654 1.83499 2.28743 1.7121 2.47792 1.62796C2.6684 1.54382 2.87433 1.50027 3.08257 1.50007H5.33257C5.69655 1.49649 6.04942 1.62538 6.32539 1.86272C6.60137 2.10006 6.78163 2.42966 6.83257 2.79007C6.92754 3.51012 7.10366 4.21712 7.35757 4.89757C7.45848 5.16602 7.48032 5.45776 7.4205 5.73823C7.36069 6.01871 7.22172 6.27616 7.02007 6.48007L6.06757 7.43257C7.13524 9.31023 8.68991 10.8649 10.5676 11.9326L11.5201 10.9801C11.724 10.7784 11.9814 10.6395 12.2619 10.5796C12.5424 10.5198 12.8341 10.5417 13.1026 10.6426C13.783 10.8965 14.49 11.0726 15.2101 11.1676C15.5744 11.219 15.9071 11.4025 16.145 11.6832C16.3828 11.9639 16.5092 12.3223 16.5001 12.6901Z",
            stroke: color,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ var Icons_PhoneDarker = (PhoneDarker);

;// CONCATENATED MODULE: ./components/PartnerCountry/ConnectWithTeam/ConnectWithTeam.tsx







const getWhatsappHref = (member)=>{
    if (member.whatsappLink) return member.whatsappLink;
    return `https://wa.me/${member.number.replace(/\D/g, "")}`;
};
const ConnectWithTeam = ({ connectWithTeamData  })=>{
    if (!connectWithTeamData) return null;
    const { title , teamMember  } = connectWithTeamData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ConnectWithTeam_module_default())["connect-with-team-container"],
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (ConnectWithTeam_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ConnectWithTeam_module_default())["team-row"],
                children: teamMember?.length > 0 && teamMember?.map((member)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ConnectWithTeam_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ConnectWithTeam_module_default())["avatar-ring"],
                                children: member.profileImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: member.profileImg.url,
                                    alt: member.profileImg.alternativeText || member.name,
                                    width: 120,
                                    height: 120,
                                    objectFit: "cover",
                                    className: (ConnectWithTeam_module_default()).avatar
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ConnectWithTeam_module_default())["person-info-container"],
                                children: [
                                    member.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (ConnectWithTeam_module_default()).name,
                                        children: member.name
                                    }),
                                    member.designation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ConnectWithTeam_module_default()).designation,
                                        dangerouslySetInnerHTML: {
                                            __html: member.designation
                                        }
                                    }),
                                    member.number && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (ConnectWithTeam_module_default())["contact-row"],
                                        href: `tel:${member.number}`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PhoneDarker, {
                                                width: 14,
                                                height: 14,
                                                color: "#226CF5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: member.number
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (ConnectWithTeam_module_default())["contact-row"],
                                        href: `mailto:${member.email}`,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mail/* default */.Z, {
                                                width: 14,
                                                height: 14,
                                                color: "#226CF5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: member.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (ConnectWithTeam_module_default())["whatsapp-button"],
                                href: getWhatsappHref(member),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Whatsapp, {
                                        width: 18,
                                        height: 18,
                                        color: "#ffffff"
                                    }),
                                    "Whatsapp"
                                ]
                            })
                        ]
                    }, member.id))
            })
        ]
    });
};
/* harmony default export */ var ConnectWithTeam_ConnectWithTeam = (ConnectWithTeam);

// EXTERNAL MODULE: ./components/PartnerCountry/DownloadCoursefinder/DownloadCoursefinder.module.scss
var DownloadCoursefinder_module = __webpack_require__(95825);
var DownloadCoursefinder_module_default = /*#__PURE__*/__webpack_require__.n(DownloadCoursefinder_module);
;// CONCATENATED MODULE: ./components/UI/Icons/GetItOnGooglePlay.tsx


const GetItOnGooglePlay = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "204",
        height: "60",
        viewBox: "0 0 204 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "204",
                height: "60",
                fill: "url(#pattern0_15584_12579)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_15584_12579",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_15584_12579",
                            transform: "matrix(0.00341997 0 0 0.0116279 -0.00444596 0)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_15584_12579",
                        width: "295",
                        height: "86",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Icons_GetItOnGooglePlay = (GetItOnGooglePlay);

;// CONCATENATED MODULE: ./components/UI/Icons/GetItOnAppleStore.tsx


const GetItOnAppleStore = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "204",
        height: "60",
        viewBox: "0 0 204 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "204",
                height: "60",
                fill: "url(#pattern0_15584_12580)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_15584_12580",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_15584_12580",
                            transform: "matrix(0.00338983 0 0 0.0115254 0 -0.00135593)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_15584_12580",
                        width: "295",
                        height: "87",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Icons_GetItOnAppleStore = (GetItOnAppleStore);

;// CONCATENATED MODULE: ./components/PartnerCountry/DownloadCoursefinder/DownloadCoursefinder.tsx






const DownloadCoursefinder = ({ downloadCoursefinderData , googlePlayHref ="https://play.google.com/store/apps/details?id=kc.coursefinder.ai" , appStoreHref ="https://apps.apple.com/ph/app/coursefinder-ai/id6473614202"  })=>{
    if (!downloadCoursefinderData) return null;
    const { title , description , productImg  } = downloadCoursefinderData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (DownloadCoursefinder_module_default())["download-coursefinder-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (DownloadCoursefinder_module_default())["section-wrapper"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DownloadCoursefinder_module_default()).content,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (DownloadCoursefinder_module_default()).heading,
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (DownloadCoursefinder_module_default()).subtext,
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (DownloadCoursefinder_module_default())["badges-row"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: googlePlayHref,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: (DownloadCoursefinder_module_default()).badge,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_GetItOnGooglePlay, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: appStoreHref,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: (DownloadCoursefinder_module_default()).badge,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_GetItOnAppleStore, {})
                                })
                            ]
                        })
                    ]
                }),
                productImg?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DownloadCoursefinder_module_default())["image-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                        src: productImg.url,
                        alt: productImg.alternativeText || title,
                        width: 460,
                        height: 480,
                        objectFit: "contain",
                        className: (DownloadCoursefinder_module_default())["product-image"]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DownloadCoursefinder_DownloadCoursefinder = (DownloadCoursefinder);

// EXTERNAL MODULE: ./components/AlliedServices/FAQs/FAQs.tsx
var FAQs = __webpack_require__(64014);
;// CONCATENATED MODULE: ./components/PartnerCountry/PartnerCountry.tsx












const PartnerCountry = ({ partnerCountryData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (PartnerCountry_module_default())["partner-country-section"],
        children: [
            partnerCountryData?.heroSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                partnerCountryData: partnerCountryData
            }),
            partnerCountryData?.tieups && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tieups_Tieups, {
                tieupsData: partnerCountryData?.tieups
            }),
            partnerCountryData?.coursefinderFeatures && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeatures_ProductFeatures, {
                productFeaturesData: partnerCountryData?.coursefinderFeatures
            }),
            partnerCountryData?.whyKc && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyKc_WhyKc, {
                whyKcData: partnerCountryData?.whyKc
            }),
            partnerCountryData?.testimonies && /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonies_Testimonies, {
                testimoniesData: partnerCountryData?.testimonies
            }),
            partnerCountryData?.howToBecomePartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToBecomePartner_HowToBecomePartner, {
                howToBecomePartnerData: partnerCountryData?.howToBecomePartner
            }),
            partnerCountryData?.connectWithTeam && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWithTeam_ConnectWithTeam, {
                connectWithTeamData: partnerCountryData?.connectWithTeam
            }),
            partnerCountryData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PartnerCountry_module_default())["faq-section-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                    faqData: partnerCountryData?.faq
                })
            }),
            partnerCountryData?.downloadCoursefinder && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadCoursefinder_DownloadCoursefinder, {
                downloadCoursefinderData: partnerCountryData?.downloadCoursefinder
            })
        ]
    });
};
/* harmony default export */ var PartnerCountry_PartnerCountry = (PartnerCountry);

;// CONCATENATED MODULE: ./pages/partners/[slug].tsx






const isEmptyData = (data)=>!data || data.length === 0;
const PartnerCountryPage = (props)=>{
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    if (props.mode === "oldUI") {
        if (isEmptyData(props.pageData)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FranchiseeComponent/* default */.Z, {
            eventData: props.pageData[0],
            countryTeamData: props?.countryTeamData
        });
    }
    if (isEmptyData(props.partnerCountryData)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    const meta = props.partnerCountryData[0]?.meta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta,
                canonicalUrl: `${"https://www.studies-overseas.com"}/partners/${props.slug}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCountry_PartnerCountry, {
                partnerCountryData: props.partnerCountryData[0]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PartnerCountryPage);


/***/ }),

/***/ 29261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FAQs_hide-scrollbar__rZMbO","faq-section":"FAQs_faq-section__UFgEn","faq-container":"FAQs_faq-container__WGje1","faq-heading":"FAQs_faq-heading__5blNy","faq-subtext":"FAQs_faq-subtext__7Eezl"};

/***/ }),

/***/ 60508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ConnectWithTeam_hide-scrollbar__s9aGf","connect-with-team-container":"ConnectWithTeam_connect-with-team-container__uDMQQ","heading":"ConnectWithTeam_heading__3IhVn","team-row":"ConnectWithTeam_team-row__Oz5rb","card":"ConnectWithTeam_card__CHe80","avatar-ring":"ConnectWithTeam_avatar-ring__EdMp2","avatar":"ConnectWithTeam_avatar__G4vQm","person-info-container":"ConnectWithTeam_person-info-container__fwl_c","name":"ConnectWithTeam_name__6iC5w","designation":"ConnectWithTeam_designation__O3Mnr","contact-row":"ConnectWithTeam_contact-row__P00Ad","whatsapp-button":"ConnectWithTeam_whatsapp-button__9jJL6"};

/***/ }),

/***/ 95825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"DownloadCoursefinder_hide-scrollbar__XL1jY","download-coursefinder-container":"DownloadCoursefinder_download-coursefinder-container__mWqAK","section-wrapper":"DownloadCoursefinder_section-wrapper__fyEy9","content":"DownloadCoursefinder_content__jV3S_","heading":"DownloadCoursefinder_heading__0Argr","subtext":"DownloadCoursefinder_subtext__fOf0d","badges-row":"DownloadCoursefinder_badges-row__767lb","badge":"DownloadCoursefinder_badge__wDe6R","image-wrapper":"DownloadCoursefinder_image-wrapper__d6GyD","product-image":"DownloadCoursefinder_product-image__UHsi4"};

/***/ }),

/***/ 87027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__6YKC6","hero-section-container":"HeroSection_hero-section-container__cMu6z","hero-picture":"HeroSection_hero-picture__9PYTU","content-container":"HeroSection_content-container__CSqAE","breadcrum-container":"HeroSection_breadcrum-container__2SQmA","heading":"HeroSection_heading__X_BRs","description":"HeroSection_description__JOxcH","feature-container":"HeroSection_feature-container__oGghZ","feature":"HeroSection_feature__E3H4W","icon-container":"HeroSection_icon-container__5UirE","feature-title":"HeroSection_feature-title__Zd7WU","button-container":"HeroSection_button-container__PhXcH","feature-container-mobile-wrapper":"HeroSection_feature-container-mobile-wrapper__6PH51","feature-container-mobile":"HeroSection_feature-container-mobile__pCpJu"};

/***/ }),

/***/ 59515:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HowToBecomePartner_hide-scrollbar__j0RKN","how-to-become-partner-container":"HowToBecomePartner_how-to-become-partner-container__3AcZ6","heading":"HowToBecomePartner_heading__iYsk6","subtext":"HowToBecomePartner_subtext__qfco4","steps-row":"HowToBecomePartner_steps-row__Q2l5b","card":"HowToBecomePartner_card__aB10Q","step-number":"HowToBecomePartner_step-number__47RxY","illustration-box":"HowToBecomePartner_illustration-box__YQSeg","card-title":"HowToBecomePartner_card-title__AiA_N","card-description":"HowToBecomePartner_card-description__pCBJJ","connector":"HowToBecomePartner_connector__TlFDT","connector-icon-desktop":"HowToBecomePartner_connector-icon-desktop__JGkC9","connector-icon-mobile":"HowToBecomePartner_connector-icon-mobile__JYBob"};

/***/ }),

/***/ 50427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"PartnerCountry_hide-scrollbar__koshP","partner-country-section":"PartnerCountry_partner-country-section__JUxKD","faq-section-wrapper":"PartnerCountry_faq-section-wrapper__CY7Pd"};

/***/ }),

/***/ 47566:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ProductFeatures_hide-scrollbar__oThup","product-features-container":"ProductFeatures_product-features-container__FX9vq","intro":"ProductFeatures_intro__a_JFR","intro-content":"ProductFeatures_intro-content__6ovNn","heading":"ProductFeatures_heading__1hZ_Y","description":"ProductFeatures_description__UUu2_","cta-button":"ProductFeatures_cta-button__O8DtR","media":"ProductFeatures_media__5S_vB","shadow-layer":"ProductFeatures_shadow-layer__3jxgO","left-img-container":"ProductFeatures_left-img-container__RR6B9","right-img-container":"ProductFeatures_right-img-container__9e3jA","video-frame":"ProductFeatures_video-frame__h0mJo","video":"ProductFeatures_video__163tQ","outer-radius":"ProductFeatures_outer-radius__Jf1Zb","play-button--playing":"ProductFeatures_play-button--playing__dN3pi","play-button":"ProductFeatures_play-button__yA8uU","grid-section":"ProductFeatures_grid-section__JOKRs","grid-heading":"ProductFeatures_grid-heading__daHWI","card-grid":"ProductFeatures_card-grid__Bsd5G","card":"ProductFeatures_card__G2da4","card-image-wrapper":"ProductFeatures_card-image-wrapper__NC_su","card-content":"ProductFeatures_card-content__O3pzE","card-title":"ProductFeatures_card-title__sN9OX","card-description":"ProductFeatures_card-description__lh6Ym"};

/***/ }),

/***/ 83179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Testimonies_hide-scrollbar__OBBv3","testimonies-container":"Testimonies_testimonies-container__InBCO","heading":"Testimonies_heading__VHhJb","carousel-wrapper":"Testimonies_carousel-wrapper__3oxLX","viewport":"Testimonies_viewport__2eE5R","slider-container":"Testimonies_slider-container__oeb_n","slider-container--centered":"Testimonies_slider-container--centered__ME5is","slide":"Testimonies_slide__1_Sxi","flip-card":"Testimonies_flip-card__qGE9n","flip-card-inner":"Testimonies_flip-card-inner__ldS2b","flip-card--flipped":"Testimonies_flip-card--flipped__sqKVb","flip-card-overlay":"Testimonies_flip-card-overlay__bQICo","flip-card-front":"Testimonies_flip-card-front__cAVXx","flip-card-back":"Testimonies_flip-card-back__jMOnx","front-overlay":"Testimonies_front-overlay__V6VmF","testimony-name":"Testimonies_testimony-name__LbDCA","testimony-designation":"Testimonies_testimony-designation__Qzoi0","quote-icon":"Testimonies_quote-icon__TjtCG","testimony-statement":"Testimonies_testimony-statement__7Sw_U","testimony-statement-text":"Testimonies_testimony-statement-text__JuPA4","back-footer":"Testimonies_back-footer__N3UHa","outer-radius":"Testimonies_outer-radius__1xouA","play-button":"Testimonies_play-button__PYAE9","nav-arrows":"Testimonies_nav-arrows__0oFVF","btcircle":"Testimonies_btcircle__l6gmT","btnCircleLeft":"Testimonies_btnCircleLeft__V7UCv","btcircle-disabled":"Testimonies_btcircle-disabled__UsD0T","video-modal-container":"Testimonies_video-modal-container__fYxZJ","modal-video":"Testimonies_modal-video__Jv4gR"};

/***/ }),

/***/ 80451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Tieups_hide-scrollbar__Wo6YS","tie-ups-container":"Tieups_tie-ups-container__qo4v9","heading":"Tieups_heading__seix2","pill-row":"Tieups_pill-row__n6H_6","pill":"Tieups_pill__SaIM_","pill-active":"Tieups_pill-active__yZTW1","marquee-wrapper":"Tieups_marquee-wrapper__ty7ud","marquee-row":"Tieups_marquee-row__FJxR4","marquee-track":"Tieups_marquee-track__M1fKN","marquee-row--single":"Tieups_marquee-row--single__pDlNq","marquee-track--single":"Tieups_marquee-track--single__G4P_m","marquee-slide":"Tieups_marquee-slide__eWKEC","logo-card":"Tieups_logo-card___kMoO","logo-badge":"Tieups_logo-badge__wOtAF","logo-name":"Tieups_logo-name__hnmpH"};

/***/ }),

/***/ 49733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"WhyKc_hide-scrollbar__eSzU8","why-kc-container":"WhyKc_why-kc-container__aZujr","circle-container":"WhyKc_circle-container__w0KFh","heading":"WhyKc_heading__WcUNa","card-grid":"WhyKc_card-grid__TuxlP","gradient-layer":"WhyKc_gradient-layer__C1rO1","card":"WhyKc_card__2DCU6","badge":"WhyKc_badge__EZB1q","badge-label":"WhyKc_badge-label__aQ6XT","card-title":"WhyKc_card-title__8UPsA","card-description":"WhyKc_card-description__PHcC5"};

/***/ }),

/***/ 20829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Modal_hide-scrollbar__F_AwE","backdrop":"Modal_backdrop__LYeoI","modal-container":"Modal_modal-container__jCOB5","close-button-container":"Modal_close-button-container__YUpBu","close-button":"Modal_close-button__8DqXp"};

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,5707,9382,5955,474,992,8219,4459,6081,9774,2888,179], function() { return __webpack_exec__(88529); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);